import { combineReducers } from 'redux';
import seoReducer from './SRP/redux/reducers';

const AppState = {
  seo: seoReducer
};

const rootReducer = combineReducers(AppState);

export type AppStateType = ReturnType<typeof rootReducer>;

export default AppState;
